import React from 'react';
import { graphql } from 'gatsby';
import { Section } from '../../Section';
import { TickList as TickListComponent } from '../../TickList';

export const TickList = ({ data, ...rest }) => (
  <Section contained narrow {...rest}>
    <TickListComponent {...data} />
  </Section>
);

export const TickListQuery = graphql`
  fragment TickList on KFH_UmbracoTickListComponentType {
    title
    lead
    content
    items {
      text
    }
  }
`;
